import * as API from '../_api';

// import View from 'ol/View';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
// import {Tile as TileLayer} from 'ol/layer';
// import BingMaps from 'ol/source/BingMaps';
import {Cluster, Vector as VectorSource} from 'ol/source';
import {Circle as CircleStyle, RegularShape, Fill, Stroke, Style, Text} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setLayers', all.data);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const init = async ({state, dispatch}) => {
  // check if hospitals are cached
  if (!state.hospitals) {
    const ret = await API.read();
    state.hospitals = ret.data.features;

    // @ts-ignore
    const features = new Array(state.hospitals.length);
    // @ts-ignore
    for (let i = 0; i < state.hospitals.length; ++i) {
      // @ts-ignore
      const coordinates: [number, number] = state.hospitals[i].geometry.coordinates;
      features[i] = new Feature(new Point(coordinates));
      // @ts-ignore
      features[i].setProperties(state.hospitals[i].properties);
    }

    const featuresVectorSource = new VectorSource({
      features,
    });

    const featuresClusterSource = new Cluster({
      distance: 40,
      source: featuresVectorSource,
    });

    // @ts-ignore
    state.hospitalsVectorLayer = new VectorLayer({
      source: featuresClusterSource,
      style: (feature: any) => {
        // TODO: add some kind of quantification for hospitals
        const size = 1;
        if (size > 1 && state.styleCacheHospital[size]) {
          return state.styleCacheHospital[size];
        }

        // TODO: get Text, fill and stroke from cache

        const params = {
          text: new Text({
            font: 'bold ' + 16 + 'px "Open Sans", "Arial Unicode MS", "sans-serif"',
            text: 'H',
            fill: new Fill({
              color: '#0084C7',
            }),
            stroke: new Stroke({
              color: '#092838',
              width: 2,
            }),
          }),
        };

        // @ts-ignore
        state.styleCacheHospital[size] = new Style(params);
        return state.styleCacheHospital[size];
      },
    });

    dispatch('map/addLayer', state.hospitalsVectorLayer, {root: true});
  }
};

// @ts-ignore
export const setVisibility = ({state}, visibility) => {
  state.hospitalsVectorLayer.setVisible(visibility);
};
